const chatSubmit = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15.707.293a1 1 0 0 0-1.043-.234l-14 5a.999.999 0 0 0-.111 1.835l4.586 2.292 4.64-3.314c.23-.164.514.119.35.349l-3.315 4.642 2.292 4.586c.17.339.518.552.895.552l.06-.002a1 1 0 0 0 .883-.662l4.999-14.001c.129-.363.037-.77-.236-1.043"/></svg>',
};

export { chatSubmit as default };
